import {IProjetAnnee} from "../model/projet-annee.model";
import {
  AdherentCiviliteEnum,
  CampAdherentStaffRoleEnum,
  CampDiscussionSujetStatusEnum,
  ProjetAnneeCodeModulesEnum,
  ProjetAnneeStatutEnum,
  StatutAvisEnum,
  StatutDeclarationEnum,
  TrimestreEnum,
  TypeAvisEnum,
  TypeMossEnum,
  ValidationLevelEnum,
  ValidationValueEnum
} from "../constant/enum";
import {IProjetAnneeModule} from "../model/projet-annee-module.model";
import {IProjetAnneeDiscussionSujet} from "../model/projet-annee-discussion-sujet.model";
import {IProjetAnneeLieu} from "../model/projet-annee-lieu.model";
import {IProjetAnneeAdherentStaff} from "../model/projet-annee-adherent-staff.model";
import {ICampAdherentStaff} from "../model/camp-adherent-staff.model";
import {getCampChefs} from "./camp-utils";
import {IAdherentInformations, IAdherentQualification} from "../model/adherent-informations.model";
import moment from "moment";
import {ICamp} from "../model/camp.model";


const validationThemes = {
  default: {classLevel: 'ddc-icon', icon: 'cancel', validationLevel: ValidationValueEnum.DEFAULT},
  info: {classLevel: 'ddc-icon-info', icon: 'check_circle', validationLevel: ValidationValueEnum.INFO},
  success: {classLevel: 'ddc-icon-success', icon: 'check_circle', validationLevel: ValidationValueEnum.SUCCESS},
  warning: {classLevel: 'ddc-icon-accent', icon: 'cancel', validationLevel: ValidationValueEnum.WARNING},
  error: {classLevel: 'ddc-icon-warm', icon: 'cancel', validationLevel: ValidationValueEnum.ERROR}
};
export function isProjetAnneeModulesActive(projetAnnee: IProjetAnnee, codeModules?: ProjetAnneeCodeModulesEnum[], typeMoss?: TypeMossEnum): boolean {
  if (projetAnnee && projetAnnee.projetAnneeModules && projetAnnee.projetAnneeModules.length > 0) {
    if (codeModules && codeModules.length > 0) { // Check by module code
      const projetAnneeModules: IProjetAnneeModule[] = projetAnnee.projetAnneeModules.filter((projetAnneeModule: IProjetAnneeModule) => codeModules.includes(projetAnneeModule.module.code));
      if (projetAnneeModules && projetAnneeModules.length > 0) {
        let isActive: boolean = false;
        projetAnneeModules.forEach((projetAnneeModule: IProjetAnneeModule) => {
          if (projetAnneeModule.actif === true) {
            isActive = true;
          }
        });
        return isActive;
      }
    } else if (typeMoss) { // Check by category code
      const index = projetAnnee.projetAnneeModules.findIndex((projetAnneeModule: IProjetAnneeModule) => projetAnneeModule.module.typeMoss === typeMoss && projetAnneeModule.actif === true);
      return index != -1 ? true : false;
    }
  }
  return false;
}

export function projetAnneeAllAlertMessages(projetAnnee: IProjetAnnee) {
   if (projetAnnee && projetAnnee._projetAnneeAllAlertsMessages) return projetAnnee._projetAnneeAllAlertsMessages;
   else return [];
}

export function getProjetAnneeLieuAddress(projetAnneeLieu: IProjetAnneeLieu) {
  let projetAnneeLieuAddress = '';
  projetAnneeLieuAddress = projetAnneeLieu.libelle ? projetAnneeLieu.libelle : '';
  projetAnneeLieuAddress = projetAnneeLieuAddress ? projetAnneeLieuAddress : '';
  if (projetAnneeLieu.tamRefCommune) {
    projetAnneeLieuAddress += ' - ' + projetAnneeLieu.tamRefCommune.codePostale + ' - ' + projetAnneeLieu.tamRefCommune.libelle;
  } else if (projetAnneeLieu.tamRefPays) {
    projetAnneeLieuAddress += projetAnneeLieu.codePostal + ' - ' + projetAnneeLieu.ville + ', ' + projetAnneeLieu.tamRefPays.libelle;
  }
  return projetAnneeLieuAddress ? projetAnneeLieuAddress : 'vide';
}

export interface IValidationTheme {
  classLevel?: string,
  icon?: string,
  validationLevel?: number
}

export function getProjetAnneeFicheDeclarationValidationLevel(ficheStatus: ProjetAnneeStatutEnum) {
  if(ficheStatus == ProjetAnneeStatutEnum.CREE) return ValidationValueEnum.DEFAULT
  if(ficheStatus == ProjetAnneeStatutEnum.A_TELEDECLARER) return ValidationValueEnum.INFO
  if(ficheStatus == ProjetAnneeStatutEnum.TELEDECLARE) return ValidationValueEnum.SUCCESS
}

export function getProjetAnneeValidationStatus(level: string, projetAnnee?: IProjetAnnee): IValidationTheme {
  let validationLevel = ValidationValueEnum.DEFAULT

  switch (level) {
    case ValidationLevelEnum.FICHE_INITIALE:
      const FI_status = projetAnnee.statut
      validationLevel = getProjetAnneeFicheDeclarationValidationLevel(FI_status) ? getProjetAnneeFicheDeclarationValidationLevel(FI_status) : ValidationValueEnum.DEFAULT
      break;
    case ValidationLevelEnum.FC_1:
      const FC1_status = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_1).statut
      validationLevel = getProjetAnneeFicheDeclarationValidationLevel(FC1_status) ? getProjetAnneeFicheDeclarationValidationLevel(FC1_status) : ValidationValueEnum.DEFAULT
      break;
    case ValidationLevelEnum.FC_2:
      const FC2_status = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_2).statut
      validationLevel = getProjetAnneeFicheDeclarationValidationLevel(FC2_status) ? getProjetAnneeFicheDeclarationValidationLevel(FC2_status) : ValidationValueEnum.DEFAULT
      break;
    case ValidationLevelEnum.FC_3:
      const FC3_status = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_3).statut
      validationLevel = getProjetAnneeFicheDeclarationValidationLevel(FC3_status) ? getProjetAnneeFicheDeclarationValidationLevel(FC3_status) : ValidationValueEnum.DEFAULT
      break;
    case ValidationLevelEnum.FC_4:
      const FC4_status = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_4).statut
      validationLevel = getProjetAnneeFicheDeclarationValidationLevel(FC4_status) ? getProjetAnneeFicheDeclarationValidationLevel(FC4_status) : ValidationValueEnum.DEFAULT
      break;
    case ValidationLevelEnum.AVIS_MARIN:
      const avisMarin = projetAnnee.projetAnneeAvis.find(avis => avis.typeAvis == TypeAvisEnum.MARIN)
      if(avisMarin != undefined) {
      if(avisMarin.statut == StatutAvisEnum.DELIVRE) validationLevel = ValidationValueEnum.SUCCESS
      if(avisMarin.statut == StatutAvisEnum.PROJ_NAV_MODIF) validationLevel = ValidationValueEnum.WARNING
      if(avisMarin.statut == StatutAvisEnum.REFUSE) validationLevel = ValidationValueEnum.ERROR
      }
      break;
    default:
      validationLevel = ValidationValueEnum.DEFAULT;
  }

  if (validationLevel === ValidationValueEnum.INFO) {
    return validationThemes.info;
  } else if (validationLevel === ValidationValueEnum.SUCCESS) {
    return validationThemes.success;
  } else if (validationLevel === ValidationValueEnum.WARNING) {
    return validationThemes.warning;
  } else if (validationLevel === ValidationValueEnum.ERROR) {
    return validationThemes.error;
  } else {
    return validationThemes.default;
  }
}

export  function getNbreProjetAnneeAdherentStaffsByGender(projetAnnee: IProjetAnnee, idCivilite: number) {
  const chefsByGender = projetAnnee.projetAnneeAdherentStaffs.filter((projetAnneeAdherentStaff: IProjetAnneeAdherentStaff) => {
    return projetAnneeAdherentStaff.adherent && projetAnneeAdherentStaff.adherent.civilite ? projetAnneeAdherentStaff.adherent.civilite.id === idCivilite : false;
  })
  return chefsByGender ? chefsByGender.length : 0;
}

export function getProjetAnneeInformation(projetAnnee: IProjetAnnee) {
  let information: IProjetAnneeInformation = {};
  let projetAnneeFC1 = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_1)
  let projetAnneeFC2 = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_2)
  let projetAnneeFC3 = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_3)
  let projetAnneeFC4 = projetAnnee.projetAnneeFcTrimestres.find(fc => fc.trimestre.code == TrimestreEnum.TRIMESTRE_4)

  //Discussion
  information.discussionsOuvertes = getNombreProjetAnneeDiscussionSujetsOuverts(projetAnnee);

  // Structure
  information.structure =  projetAnnee.structureProjetAnnee.libelle

  //Lieu - un seul lieu pour les projets d'année
  const projetAnneeLieu = projetAnnee.projetAnneeLieux[0]
  information.lieuPrincipal = projetAnneeLieu ? getProjetAnneeLieuAddress(projetAnneeLieu) : '';

  //Directeurs
  const directors = projetAnnee.projetAnneeAdherentStaffs.filter((adherentStaff: IProjetAnneeAdherentStaff) => adherentStaff.roleStaff === CampAdherentStaffRoleEnum.DIRECTEUR)
  const directorsNames = directors.map((director: IProjetAnneeAdherentStaff) => `${director.adherent.prenom} ${director.adherent.nom}`);
  information.directeurs = directorsNames.join('/');

  //Chefs/Staffs
  information.nbEncadrantsTotal = projetAnnee.projetAnneeAdherentStaffs ? projetAnnee.projetAnneeAdherentStaffs.length : 0
  information.nbEncadrantsHommes = getNbreProjetAnneeAdherentStaffsByGender(projetAnnee,  AdherentCiviliteEnum.MALE)
  information.nbEncadrantsFemmes = getNbreProjetAnneeAdherentStaffsByGender(projetAnnee,  AdherentCiviliteEnum.FEMALE)


  //Qualifications DSF et ASF
  const regExpDSF = new RegExp('DSF', 'g');
  const regExpASF = new RegExp('ASF', 'g');
  let nbreDirecteursDSF = 0;
  let nbreAnimateursASF = 0;
  let nbreAnimateursASFStagiaire = 0;

  if (projetAnnee.projetAnneeAdherentStaffsInformations) {
    // Directeurs
    directors.forEach((director: IProjetAnneeAdherentStaff) => {
      const adherentInformations = projetAnnee.projetAnneeAdherentStaffsInformations.find((projetAnneeAdherentStaffsInformations: IAdherentInformations) => projetAnneeAdherentStaffsInformations.numero === director.adherent.numero);
      const qualificationsDSF = adherentInformations && adherentInformations.adherentQualifications ?
        adherentInformations.adherentQualifications.filter((qualification: IAdherentQualification) => qualification.type.match(regExpDSF) && qualification.estTitulaire)
        : [];
      if (qualificationsDSF || qualificationsDSF.length > 0) {
        nbreDirecteursDSF++;
      }
    });

    // Animateurs
    const animateurs = projetAnnee.projetAnneeAdherentStaffs ?
      projetAnnee.projetAnneeAdherentStaffs.filter((projetAnneeAdherentStaffs: IProjetAnneeAdherentStaff) => projetAnneeAdherentStaffs.roleStaff !== CampAdherentStaffRoleEnum.DIRECTEUR) : [];
    animateurs.forEach((animateur: ICampAdherentStaff) => {
      const adherentInformations = projetAnnee.projetAnneeAdherentStaffsInformations.find((projetAnneeAdherentStaffs: IAdherentInformations) => projetAnneeAdherentStaffs.numero === animateur.adherent.numero);
      const qualificationsASF = adherentInformations && adherentInformations.adherentQualifications ?
        adherentInformations.adherentQualifications.filter((qualification: IAdherentQualification) => qualification.type.match(regExpASF) && ((qualification.dateFin && moment(qualification.dateFin).diff(projetAnneeFC4.dateFin) >= 0) || !qualification.dateFin))
        : [];
      if (qualificationsASF && qualificationsASF.length > 0) {
        const qualificationASFNonStagiare =
          qualificationsASF.filter((qualification: IAdherentQualification) => qualification.estTitulaire === true);
        if (qualificationASFNonStagiare && qualificationASFNonStagiare.length > 0) {
          nbreAnimateursASF++;
        } else {
          nbreAnimateursASFStagiaire++;
        }
      }
    });
  }
  information.nbreDirecteursDSF = nbreDirecteursDSF;
  information.nbreAnimateursASF = nbreAnimateursASF;
  information.nbreAnimateursASFStagiaire = nbreAnimateursASFStagiaire;
  information.nbStagiairesBafa = projetAnnee.projetAnneeAdherentStaffs ?  projetAnnee.projetAnneeAdherentStaffs.filter((projetAnneeAdherentStaff: IProjetAnneeAdherentStaff) => projetAnneeAdherentStaff.validationStagePratiqueBafa === true).length : 0;
  information.nbStagiairesBafd = projetAnnee.projetAnneeAdherentStaffs ?  projetAnnee.projetAnneeAdherentStaffs.filter((projetAnneeAdherentStaff: IProjetAnneeAdherentStaff) => projetAnneeAdherentStaff.validationStagePratiqueBafd === true).length : 0;

  return information;
}

export interface IProjetAnneeInformation {
  structure?: string;
  directeurs?: string;
  discussionsOuvertes?: number;
  lieuPrincipal?: string;
  nbEncadrantsTotal?: number;
  nbEncadrantsHommes?: number;
  nbEncadrantsFemmes?: number;
  nbreDirecteursDSF?: number;
  nbreAnimateursASF?:  number;
  nbreAnimateursASFStagiaire?: number;
  nbStagiairesBafa?: number;
  nbStagiairesBafd?:number;
}

export function getNombreProjetAnneeDiscussionSujetsOuverts(projetAnnee: IProjetAnnee) {
  const projetAnneeDiscussionSujetsOuverts: IProjetAnneeDiscussionSujet[] =
    projetAnnee.projetAnneeDiscussionSujets ?
      projetAnnee.projetAnneeDiscussionSujets.filter((projetAnneeDiscussionSujet: IProjetAnneeDiscussionSujet) => projetAnneeDiscussionSujet.statut === CampDiscussionSujetStatusEnum.OUVERTE)
      : [];
  return projetAnneeDiscussionSujetsOuverts ? projetAnneeDiscussionSujetsOuverts.length : 0;
}
